/* istanbul ignore file */
import { Injectable } from '@angular/core';

import { ItemToolbarConfiguration } from '@mirage-projects/cw-commons';

import itemsToolbarConfiguration from '@collageweb/assets/configuration/items-toolbar-configuration.json';

@Injectable({ providedIn: 'root' })
export class ToolsConfigurationService {
    static toolbarConfig: ItemToolbarConfiguration[] = itemsToolbarConfiguration as ItemToolbarConfiguration[];
}
